<template>
  <v-form v-model="valid" ref="form" @submit.prevent="changePassword">
    <v-row>
      <v-col cols="12">
        <v-text-field
          v-model="form.password"
          :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
          v-on:click:append="show = !show"
          :type="show ? 'text' : 'password'"
          :rules="[rules.required, rules.password.min]"
          v-bind="fieldProps2"
          placeholder="new password"
          hide-details="auto"
        >
        </v-text-field>
      </v-col>

      <v-col cols="12">
        <v-text-field
          v-model="cpassword"
          :rules="confirmPasswordRule"
          :append-icon="showcp ? 'mdi-eye' : 'mdi-eye-off'"
          v-on:click:append="showcp = !showcp"
          :type="showcp ? 'text' : 'password'"
          v-bind="fieldProps2"
          placeholder="confirm new password"
        ></v-text-field>
      </v-col>

      <v-col cols="12">
        <v-btn
          :loading="loading"
          type="submit"
          v-bind="btnProps2"
          class="primary"
          block
        >
          continue
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { rules, fieldProps2, btnProps2 } from "@/helpers";
import { mapActions } from "vuex";

export default {
  name: "Forgot",

  data: () => ({
    rules,
    fieldProps2,
    btnProps2,

    valid: true,
    loading: false,

    form: {
      password: "",
    },
    cpassword: "",

    show: false,
    showcp: false,
  }),

  computed: {
    confirmPasswordRule() {
      return [
        (v) => !!v || "Please confirm your password",
        (v) => v === this.form.password || "Passwords must match.",
      ];
    },
  },

  methods: {
    ...mapActions(["makeFetch"]),

    async submit(path, method, loadingVar, data, token) {
      this.loading = true;

      const reqData = {
        method: method,
        goTo: path,
      };

      !!data && (reqData.data = data);
      !!token && (reqData.useToken = token);

      const res = await this.makeFetch({ ...reqData })
        .catch(console.error)
        .finally(() => (this.loading = false));

      return res;
    },

    async changePassword() {
      if (!this.$refs.form.validate()) return;

      const { password } = this.form;
      const token = localStorage.getItem("tkn");

      const res = await this.submit(
        "/user_reset_password",
        "post",
        "reset",
        {
          password: password,
          password_confirmation: password,
        },
        token
      );

      this.$emit("onPasswordChange", res);
    },
  },
};
</script>
